import { DomEvent } from "./DomEvent";
import { DropdownItem } from "../components/textbox/DropdownItem";
import { Event, EventListener } from "./Event";
import { Textbox } from "../components/textbox/Textbox";
import { TypedSelectionEvent } from "./TypedSelectionEvent";

export interface DropdownSelectionListener extends EventListener<DropdownSelectionEvent> {
}

export class DropdownSelectionEvent extends TypedSelectionEvent<DropdownItem> {

    constructor(component: Textbox, selectedItems?: DropdownItem | DropdownItem[],
        deselectedItems?: DropdownItem | DropdownItem[], domEvent?: Event | DomEvent) {
        super(component, selectedItems, deselectedItems, domEvent);
    }
}
